var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23C17.8513 23 23 17.8513 23 11.5C22.9926 5.15179 17.8482 0.00739331 11.5 0Z",
    fill: "#095228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2819 8.35705L11.5778 16.0979C11.4417 16.2784 11.2389 16.3966 11.0148 16.4261C10.7907 16.4556 10.5642 16.3938 10.3861 16.2546L6.31277 12.9979C5.95333 12.7102 5.89513 12.1857 6.18277 11.8262C6.47042 11.4668 6.995 11.4086 7.35444 11.6962L10.7511 14.4137L15.9403 7.37122C16.1104 7.11588 16.4072 6.97471 16.7126 7.00375C17.0181 7.0328 17.2829 7.22736 17.4019 7.5102C17.5209 7.79303 17.4748 8.11838 17.2819 8.35705Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.ae890af86a404c91c8217ad0d5e39e7d.svg";
export { ForwardRef as ReactComponent };